<div class="container-fluid d-flex ">

    <span class="logout-button">
        <img src="../../../assets/logout.png" (click)="logout()" style="width: 20px;  height: 20px;  margin-top: 8px;">
    </span>


    <div class="justify-content-center align-items-center row w-100 my-auto">

        <div class="col-sm-6">

            <h1 class="card-title text-center">
                Access Restricted<br>
                <span> You are not Authorized to view this page</span>
            </h1>
        </div>

    </div>
</div>